<div class="master-modal reviepw_items_modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title"> Stop Bid </h4>
        <div class="modal_close_btn">
          <span (click)="closeDialog('no')" class="modal-close"><i class="material-icons">close</i></span>
        </div>
      </div>
      <!-- Modal content-->
        <perfect-scrollbar class="modal-body-scrollbar">
          <div mat-dialog-content>
            <div class="modal-body">
               <p>
                 Are you really want to stop biding this pre owned supplies ?
               </p>

               <mat-form-field appearance="outline">
                <textarea matInput formControlName="stop_bid_reason" placeholder="Enter stopping reason"></textarea>
                <mat-error *ngIf="stop_bid_reason.invalid && (stop_bid_reason.dirty || stop_bid_reason.touched)">
                   <span *ngIf="stop_bid_reason.hasError('required')">
                     Stopping reason is required  </span>
                </mat-error>
              </mat-form-field>

            </div>
          </div>
        </perfect-scrollbar>
        <!-- Modal-Footer -->
        <div class="modal-footer">
          <div mat-dialog-actions class="modal_footer">
            <button type="button" mat-button (click)="closeDialog('no')" class="modal-cancel-btn modal-footer-btn">
              <span> Cancel </span>
            </button>
            <button type="button" mat-button (click)="updateSecondHandSupply()" class="modal-save-btn global-btn modal-footer-btn">
              <span> Stop bid </span>
            </button>
          </div>
        </div>
    </div>
  </div>
</div>
